module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "sidebar-menu"
  }, [_c('li', {
    staticClass: "header"
  }, [_vm._v("MENU DE NAVEGAÇÃO")]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-desktop"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Início")])])]), _vm._v(" "), (this.hasPermission('usuario')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/operacao/garantias/nova"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Nova Garantia")])])]) : _vm._e(), _vm._v(" "), (this.hasPermission('usuario')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/operacao/garantias/impressao"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-barcode"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Impressão de Boletos")])])]) : _vm._e(), _vm._v(" "), (this.hasPermission('usuario')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/financeiro/recebimentos"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-money"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Recebimentos")])])]) : _vm._e(), _vm._v(" "), (this.hasPermission('usuario') && this.$store.state.user.empresa.antecipa == 'S') ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/operacao/antecipacoes"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-reply"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Antecipações")])])]) : _vm._e(), _vm._v(" "), (this.hasPermission('usuario') && this.$store.state.user.empresa.simula_venda == 'S') ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/operacao/antecipacoes/simular-venda"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-list-ul"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Simular Venda com Taxas")])])]) : _vm._e(), _vm._v(" "), (this.hasPermission('usuario')) ? _c('li', {
    staticClass: "treeview"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (this.hasPermission('administrador')) ? _c('li', {
    staticClass: "header"
  }, [_vm._v("OPERAÇÃO")]) : _vm._e(), _vm._v(" "), (this.hasPermission('administrador')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/operacao/garantias"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-exchange"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Garantias")])])]) : _vm._e(), _vm._v(" "), (this.hasPermission('administrador')) ? _c('router-link', {
    staticClass: "pageLink",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "tag": "li",
      "to": "/operacao/remessas"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-mail-forward"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Remessas")])])]) : _vm._e(), _vm._v(" "), (this.hasPermission('administrador')) ? _c('router-link', {
    staticClass: "pageLink",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "tag": "li",
      "to": "/operacao/retornos"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-mail-reply"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Retornos")])])]) : _vm._e(), _vm._v(" "), (this.hasPermission('administrador')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/operacao/antecipacoes"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-reply"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Antecipações")])])]) : _vm._e(), _vm._v(" "), (this.hasPermission('administrador')) ? _c('li', {
    staticClass: "header"
  }, [_vm._v("FINANCEIRO")]) : _vm._e(), _vm._v(" "), (this.hasPermission('administrador')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/financeiro/relatorios/faturamento"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-money"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Faturamento")])])]) : _vm._e(), _vm._v(" "), (this.hasPermission('administrador')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/financeiro/relatorios/fechamento"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Relatório de Fechamento")])])]) : _vm._e(), _vm._v(" "), (this.hasPermission('administrador')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/financeiro/boletos"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-barcode"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Boletos Garantidos")])])]) : _vm._e(), _vm._v(" "), (this.hasPermission('administrador')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/financeiro/boletos-avulsos"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-barcode"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Boletos Avulsos")])])]) : _vm._e(), _vm._v(" "), (this.hasPermission('administrador')) ? _c('li', {
    staticClass: "header"
  }, [_vm._v("COBRANÇA")]) : _vm._e(), _vm._v(" "), (this.hasPermission('administrador')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/cobranca/inadimplentes"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-exchange"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Inadimplentes")])])]) : _vm._e(), _vm._v(" "), (this.hasPermission('administrador')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/cobranca/agendamentos"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-exchange"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Agendamentos")])])]) : _vm._e(), _vm._v(" "), (this.hasPermission('administrador')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/cobranca/acordos"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-exchange"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Acordos")])])]) : _vm._e(), _vm._v(" "), (this.hasPermission('administrador')) ? _c('li', {
    staticClass: "header"
  }, [_vm._v("ADMINISTRAÇÃO")]) : _vm._e(), _vm._v(" "), (this.hasPermission('administrador')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/administracao/usuarios"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-users"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Usuários do Sistema")])])]) : _vm._e(), _vm._v(" "), (this.hasPermission('administrador')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/administracao/empresas"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-bank"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Empresas")])])]) : _vm._e(), _vm._v(" "), (this.hasPermission('administrador')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/cadastros/empresas"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-user-secret"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Franqueados")])])]) : _vm._e(), _vm._v(" "), (this.hasPermission('administrador')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/administracao/pessoas"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Pessoas")])])]) : _vm._e(), _vm._v(" "), (this.hasPermission('administrador')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/cadastros/empresas"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-close"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Inadimplentes")])])]) : _vm._e(), _vm._v(" "), (this.hasPermission('administrador')) ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/cadastros/empresas"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("CPFs Suspeitos")])])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "http://chat.credipremium.com.br/chat",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-wechat"
  }), _c('span', [_vm._v("Chat")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35b07c64"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SidebarMenu.vue
// module id = 392
// module chunks = 1